import React from "react";
import InfoIcon from "@mui/icons-material/InfoOutlined";
import ActionButtons from "../../../shared/components/common/ActionButtons";
import StatusBadge from "../../../shared/components/common/StatusBadge";
import Tooltip from "../../../shared/components/common/Tooltip";

export const buildUserColumns = ({
  selectedRows,
  setSelectedRows,
  filteredUsers,
  onEdit,
  onDelete,
  currentUserEmail,
}) => [
  {
    Header: () => (
      <input
        type="checkbox"
        checked={
          selectedRows.size === filteredUsers.length && filteredUsers.length > 0
        }
        onChange={(e) => {
          if (e.target.checked) {
            setSelectedRows(new Set(filteredUsers.map((u) => u.id)));
          } else {
            setSelectedRows(new Set());
          }
        }}
        className="w-4 h-4 text-primary border-gray-300 rounded-sm focus:ring-primary !bg-primary"
      />
    ),
    accessor: "checkbox",
    disableSortBy: true,
    Cell: ({ row }) => (
      <input
        type="checkbox"
        checked={selectedRows.has(row.original.id)}
        onChange={(e) => {
          const newSelected = new Set(selectedRows);
          if (e.target.checked) {
            newSelected.add(row.original.id);
          } else {
            newSelected.delete(row.original.id);
          }
          setSelectedRows(newSelected);
        }}
        className="w-4 h-4 text-primary border-gray-300 rounded-sm focus:ring-primary"
      />
    ),
  },
  {
    Header: "FIRST NAME",
    accessor: "firstName",
    Cell: ({ value }) => (
      <span className="text-content text-xs sm:text-sm">{value}</span>
    ),
  },
  {
    Header: "LAST NAME",
    accessor: "lastName",
    Cell: ({ value }) => (
      <span className="text-content text-xs sm:text-sm">{value}</span>
    ),
  },
  {
    Header: () => (
      <div className="flex items-center gap-1">
        <span>TO ADDRESS</span>
        <Tooltip text="Email address where PBX voicemails are sent to for transcription.">
          <InfoIcon className="text-xs text-gray-500 cursor-help" />
        </Tooltip>
      </div>
    ),
    accessor: "toAddress",
    Cell: ({ value }) => (
      <span className="text-content text-xs sm:text-sm">{value || "—"}</span>
    ),
  },
  {
    Header: () => (
      <div className="flex items-center gap-1">
        <span>DELIVERY ADDRESS</span>
        <Tooltip text="End user email address to deliver transcribed messages to">
          <InfoIcon className="text-[10px] text-content cursor-help" />
        </Tooltip>
      </div>
    ),
    accessor: "deliveryAddress",
    Cell: ({ value }) => (
      <span className="text-content text-xs sm:text-sm">{value}</span>
    ),
  },
  {
    Header: "EMAIL MODE",
    accessor: "emailMode",
    disableSortBy: true,
    Cell: ({ value }) => <StatusBadge status={value} variant="email" />,
  },
  {
    Header: "SMS MODE",
    accessor: "smsMode",
    disableSortBy: true,
    Cell: ({ value }) => <StatusBadge status={value} variant="sms" />,
  },
  {
    Header: "MOBILE NUMBER",
    accessor: "mobileNumber",
    Cell: ({ value }) => (
      <span className="text-content text-xs sm:text-sm">{value || "—"}</span>
    ),
  },
  {
    Header: "VOICEMAIL NUMBER",
    accessor: "voicemailNumber",
    Cell: ({ value }) => (
      <span className="text-content text-xs sm:text-sm">{value || "—"}</span>
    ),
  },
  {
    Header: "TIME ZONE",
    accessor: "timeZone",
    Cell: ({ value }) => (
      <span className="text-content text-xs sm:text-sm">{value}</span>
    ),
  },
  {
    Header: "ACTIONS",
    accessor: "actions",
    disableSortBy: true,
    Cell: ({ row }) => (
      <div className="flex items-center gap-2">
        <ActionButtons
          onEdit={() => onEdit(row.original)}
          onDelete={() => onDelete(row.original.id)}
          userEmail={row.original.deliveryAddress || row.original.toAddress || ""}
          currentUserEmail={currentUserEmail}
        />
      </div>
    ),
  },
];

export default buildUserColumns;
